<template>

<div class="main">
  <div class="main-context">
     <el-row :gutter="16" class="am-margin-top-sm">
    <el-col :span="24">
        <column-basic :text="text">
            <list-thum :list="list.dt" >
            </list-thum>
           </column-basic>
       <el-pagination 
       class="am-margin-vertical-sm am-text-right"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-size="20"
        layout="total, prev, pager, next"
        :total="list.countRow">
      </el-pagination>
    </el-col>
  </el-row>

  </div>
</div>
 
</template>

<script>
  import ListThum from '@/components/list/ListThum'
   import ColumnBasic from '@/components/column/ColumnBasic'
 import {listSearch} from '@/api/list'
export default {
  name: 'search',
  components: {
     ListThum,ColumnBasic
    },
  data(){
    return {
      text:'',
      list:{
          dt:[],
          countRow:0
        },
       currentPage:1
    }
  },
  methods:{
     currentChange(currentPage){
        this.currentPage=currentPage
        listSearch(this.findInfo,this.currentPage).then(result=>{
          this.list=result
         window.scrollTo(0,0);  
        })
      },
  },
  computed:{
    findInfo(){
      return this.$route.params.findInfo||' '
    }
  },
  watch:{
    findInfo(curr,prev){
      document.title = `"${curr}"的搜索结果`;
       this.text = `"${curr}"的搜索结果`;
      listSearch(curr,this.currentPage).then(result=>{
      if(result.countRow==0)this.$message.info("没有找到符合条件的文章")
        this.list=result
      })
    }
  },
  created(){
     document.title = `"${this.findInfo}"的搜索结果`;
      this.text = `"${this.findInfo}"的搜索结果`;
     listSearch(this.findInfo,this.currentPage).then(result=>{
      if(result.countRow==0)this.$message.info("没有找到符合条件的文章")
        this.list=result
      })
  }

}
</script>
